import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // 主页
    {
      // 地址
      path: '/',
      // 路由名称
      name: 'home',
      // 同步载入组件
      component: () => import('./views/Login/index.vue')
    }
    // {
    //   // 地址
    //   path: '/login',
    //   // 路由名称
    //   name: 'home',
    //   // 同步载入组件
    //   component: () => import('./views/Login/index.vue')
    // }
  ]
})

export default router
